import { canViewMyPortfolioToggle } from "./my-relationships/relationshipTabAccess";
import type { RelationshipAssessmentStakeholder } from "../../Store/Reducers/RelationshipSlice";

function resolveLoggedInUserId(
  loggedInUser?: {
    user_id?: string;
    userId?: string;
    id?: string;
  } | null
): string {
  return String(
    loggedInUser?.user_id || loggedInUser?.userId || loggedInUser?.id || ""
  ).trim();
}

function findCurrentStakeholder(
  stakeholders: RelationshipAssessmentStakeholder[],
  loggedInUser?: {
    user_id?: string;
    userId?: string;
    id?: string;
    email?: string | null;
  } | null
): RelationshipAssessmentStakeholder | undefined {
  const userId = resolveLoggedInUserId(loggedInUser);
  if (userId) {
    const match = stakeholders.find(
      stakeholder => String(stakeholder.user_id) === userId
    );
    if (match) return match;
  }

  const email = String(loggedInUser?.email || "")
    .trim()
    .toLowerCase();
  if (!email) return undefined;

  return stakeholders.find(
    stakeholder =>
      String(stakeholder.email || "")
        .trim()
        .toLowerCase() === email
  );
}

export function resolveInitialStakeholderUserIds(
  stakeholders: RelationshipAssessmentStakeholder[] = [],
  loggedInUser?: {
    role?: string | null;
    user_id?: string;
    userId?: string;
    id?: string;
    email?: string | null;
  } | null
): string[] {
  if (!stakeholders.length) return [];

  if (canViewMyPortfolioToggle(loggedInUser?.role)) {
    const currentStakeholder = findCurrentStakeholder(
      stakeholders,
      loggedInUser
    );
    return currentStakeholder ? [currentStakeholder.user_id] : [];
  }

  return stakeholders.map(stakeholder => stakeholder.user_id);
}
